{
  "FormEngineInputElement": {
    "title": "Eingang"
  },
  "mask": {
    "FormEngineInputElement": {
      "groupTitle": "Eingang",
      "showError": "Fehler anzeigen",
      "autoComplete": "Automatisch vervollständigen"
    }
  }
}